// project import
import MainLayout from 'layout/MainLayout';
import LoginGuard from 'layout/LoginLayout/guard';

const LoginLayout = () => (
  <LoginGuard>
    <MainLayout />
  </LoginGuard>
);

export default LoginLayout;
